module.exports = __webpack_public_path__ + "static/img/sutra01.3fdd275.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/sutras/sutra01.jpg
// module id = GEWw
// module chunks = 3